import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { MemberService, SexEnum } from 'src/app/backend';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { SaveMemberDialogComponent } from 'src/app/shared/dialogs/save-member-dialog/save-member-dialog.component';
import { BasePagedComponent } from '../../core/components/base-paged/base-paged.component';
import { DialogService } from '../../core/dialog/dialog.service';
import { AuthService } from '../../core/services/auth.service';
import { UntypedFormControl } from '@angular/forms';

interface MemberRow {
  id: number;
  name: string;
  note: string;
  dateOfBirth: string;
  sex: SexEnum;
  representative: string;
  representativePhone: string;
  residence: string;
  city: string;
  phone: string;
}

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
})
export class MembersComponent extends BasePagedComponent implements OnInit {
  data: MemberRow[] = [];
  exportdata: MemberRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  fromQueryControl = new UntypedFormControl('');
  toQueryControl = new UntypedFormControl('');
  isLoading = false;
  totalResults = 0;

  constructor(
    private dialogService: DialogService,
    private membersServices: MemberService,
    authService: AuthService,
    t: TranslateService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
  }

  ngOnInit() {
    this.loadData();
  }



  loadData() {
    this.isLoading = true;

    this.membersServices
      .apiMemberGet({
        ...this.tableData,
        filter: JSON.stringify({
          search: this.searchQueryControl.value,
          yfrom: this.fromQueryControl.value,
          yto: this.toQueryControl.value,
        }),     
      })
      .subscribe(
        (res) => {
          this.pageLoaded(res);
          console.log(res);
          this.totalResults = res.totalResults || 0;
          this.isLoading = false;
          this.tableData.total = res.totalResults || 0;
          this.data =
            res.results?.map((x) => ({
              id: x.id || 0,
              name: x.name || '',
              note: x.note || '',
              dateOfBirth: moment(x.dateOfBirth).format('MM/DD/YYYY'),
              sex: x.sex || SexEnum.Male,
              representative: x.family?.representative || '',
              representativePhone: x.family?.phone || '',
              city: x.family?.city || '',
              residence: x.family?.residence || '',
              phone: x.family?.phone || '',
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  loadData2() {
    this.isLoading = true;

    this.membersServices
      .apiMemberGet({
        filter: JSON.stringify({
          search: this.searchQueryControl.value,
          yfrom: this.fromQueryControl.value,
          yto: this.toQueryControl.value,
        }),
        pageSize: 500,        
      })
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.exportdata =
            res.results?.map((x) => ({
              id: x.id || 0,
              name: x.name || '',
              note: x.note || '',
              dateOfBirth: moment(x.dateOfBirth).format('MM/DD/YYYY'),
              sex: x.sex || SexEnum.Male,
              representative: x.family?.representative || '',
              representativePhone: x.family?.phone || '',
              city: x.family?.city || '',
              residence: x.family?.residence || '',
              phone: x.family?.phone || '',
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  searchDonations() {
    this.loadData();

  }

  exportToExcel() {
   this.loadData2();
   this.isLoading = true;
   setTimeout(() => {
    import('xlsx').then(xlsx => {
      const exportData = this.exportdata.map(({ id, note, ...rest1 }) => rest1);
      const worksheet = xlsx.utils.json_to_sheet(exportData);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Members');
      const today = moment().format('YYYY-MM-DD');
      xlsx.writeFile(workbook, `members_${today}.xlsx`);
    });
    this.isLoading = false;
   }, 5000); // Give time for loadData2 to complete
  }

  new() {
    this.dialogService
      .open(SaveMemberDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  edit(id: number) {
    this.dialogService
      .open(SaveMemberDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
        data: {
          id,
        },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  delete(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'sm',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.membersServices.apiMemberIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
   }
}
